function index_index() {
  return import(
    /* webpackChunkName: "page-index-index" */ '@/pages/index/index.vue'
  )
}
function cadastros() {
  return import(
    /* webpackChunkName: "page-cadastros" */ '@/pages/cadastros.vue'
  )
}
function dashboard() {
  return import(
    /* webpackChunkName: "page-dashboard" */ '@/pages/dashboard.vue'
  )
}
function admcartao_index() {
  return import(
    /* webpackChunkName: "page-admcartao-index" */ '@/pages/admcartao/index.vue'
  )
}
function classe_index() {
  return import(
    /* webpackChunkName: "page-classe-index" */ '@/pages/classe/index.vue'
  )
}
function dcb_index() {
  return import(
    /* webpackChunkName: "page-dcb-index" */ '@/pages/dcb/index.vue'
  )
}
function farmaceuticas_index() {
  return import(
    /* webpackChunkName: "page-farmaceuticas-index" */ '@/pages/farmaceuticas/index.vue'
  )
}
function fornecedores_index() {
  return import(
    /* webpackChunkName: "page-fornecedores-index" */ '@/pages/fornecedores/index.vue'
  )
}
function groupPermission_index() {
  return import(
    /* webpackChunkName: "page-groupPermission-index" */ '@/pages/groupPermission/index.vue'
  )
}
function groupProducts_index() {
  return import(
    /* webpackChunkName: "page-groupProducts-index" */ '@/pages/groupProducts/index.vue'
  )
}
function lab_index() {
  return import(
    /* webpackChunkName: "page-lab-index" */ '@/pages/lab/index.vue'
  )
}
function laboratorio_index() {
  return import(
    /* webpackChunkName: "page-laboratorio-index" */ '@/pages/laboratorio/index.vue'
  )
}
function methods_index() {
  return import(
    /* webpackChunkName: "page-methods-index" */ '@/pages/methods/index.vue'
  )
}
function ncm_index() {
  return import(
    /* webpackChunkName: "page-ncm-index" */ '@/pages/ncm/index.vue'
  )
}
function pbm_index() {
  return import(
    /* webpackChunkName: "page-pbm-index" */ '@/pages/pbm/index.vue'
  )
}
function prescritor_index() {
  return import(
    /* webpackChunkName: "page-prescritor-index" */ '@/pages/prescritor/index.vue'
  )
}
function users_index() {
  return import(
    /* webpackChunkName: "page-users-index" */ '@/pages/users/index.vue'
  )
}
function admcartao_create_index() {
  return import(
    /* webpackChunkName: "page-admcartao-create-index" */ '@/pages/admcartao/create/index.vue'
  )
}
function classe_addClasse() {
  return import(
    /* webpackChunkName: "page-classe-addClasse" */ '@/pages/classe/addClasse.vue'
  )
}
function classe_editClasse() {
  return import(
    /* webpackChunkName: "page-classe-editClasse" */ '@/pages/classe/editClasse.vue'
  )
}
function classe_viewClasse() {
  return import(
    /* webpackChunkName: "page-classe-viewClasse" */ '@/pages/classe/viewClasse.vue'
  )
}
function classe_codigo_index() {
  return import(
    /* webpackChunkName: "page-classe-codigo-index" */ '@/pages/classe/codigo/index.vue'
  )
}
function dcb_addDcb() {
  return import(
    /* webpackChunkName: "page-dcb-addDcb" */ '@/pages/dcb/addDcb.vue'
  )
}
function dcb_editDcb() {
  return import(
    /* webpackChunkName: "page-dcb-editDcb" */ '@/pages/dcb/editDcb.vue'
  )
}
function dcb_viewDcb() {
  return import(
    /* webpackChunkName: "page-dcb-viewDcb" */ '@/pages/dcb/viewDcb.vue'
  )
}
function dcb_code_index() {
  return import(
    /* webpackChunkName: "page-dcb-code-index" */ '@/pages/dcb/code/index.vue'
  )
}
function farmaceuticas_create_index() {
  return import(
    /* webpackChunkName: "page-farmaceuticas-create-index" */ '@/pages/farmaceuticas/create/index.vue'
  )
}
function formasFarma_addOrUpdateFormaFarma() {
  return import(
    /* webpackChunkName: "page-formasFarma-addOrUpdateFormaFarma" */ '@/pages/formasFarma/addOrUpdateFormaFarma.vue'
  )
}
function formasFarma_areaFormaFarma() {
  return import(
    /* webpackChunkName: "page-formasFarma-areaFormaFarma" */ '@/pages/formasFarma/areaFormaFarma.vue'
  )
}
function fornecedores_create_index() {
  return import(
    /* webpackChunkName: "page-fornecedores-create-index" */ '@/pages/fornecedores/create/index.vue'
  )
}
function groupPermission_create_index() {
  return import(
    /* webpackChunkName: "page-groupPermission-create-index" */ '@/pages/groupPermission/create/index.vue'
  )
}
function groupProducts_create_index() {
  return import(
    /* webpackChunkName: "page-groupProducts-create-index" */ '@/pages/groupProducts/create/index.vue'
  )
}
function groupProducts_ensaio_index() {
  return import(
    /* webpackChunkName: "page-groupProducts-ensaio-index" */ '@/pages/groupProducts/ensaio/index.vue'
  )
}
function groupProducts_farmacopeia_index() {
  return import(
    /* webpackChunkName: "page-groupProducts-farmacopeia-index" */ '@/pages/groupProducts/farmacopeia/index.vue'
  )
}
function groupUsers_addOrUpdate() {
  return import(
    /* webpackChunkName: "page-groupUsers-addOrUpdate" */ '@/pages/groupUsers/addOrUpdate.vue'
  )
}
function groupUsers_registerClients() {
  return import(
    /* webpackChunkName: "page-groupUsers-registerClients" */ '@/pages/groupUsers/registerClients.vue'
  )
}
function laboratorio_addLaboratorio() {
  return import(
    /* webpackChunkName: "page-laboratorio-addLaboratorio" */ '@/pages/laboratorio/addLaboratorio.vue'
  )
}
function laboratorio_editLaboratorio() {
  return import(
    /* webpackChunkName: "page-laboratorio-editLaboratorio" */ '@/pages/laboratorio/editLaboratorio.vue'
  )
}
function laboratorio_viewLaboratorio() {
  return import(
    /* webpackChunkName: "page-laboratorio-viewLaboratorio" */ '@/pages/laboratorio/viewLaboratorio.vue'
  )
}
function methods_addOrUpdateMethod() {
  return import(
    /* webpackChunkName: "page-methods-addOrUpdateMethod" */ '@/pages/methods/addOrUpdateMethod.vue'
  )
}
function methods_areaMethod() {
  return import(
    /* webpackChunkName: "page-methods-areaMethod" */ '@/pages/methods/areaMethod.vue'
  )
}
function microComp_areaMicroComp() {
  return import(
    /* webpackChunkName: "page-microComp-areaMicroComp" */ '@/pages/microComp/areaMicroComp.vue'
  )
}
function ncm_create_index() {
  return import(
    /* webpackChunkName: "page-ncm-create-index" */ '@/pages/ncm/create/index.vue'
  )
}
function pbm_addOrUpdatePbm() {
  return import(
    /* webpackChunkName: "page-pbm-addOrUpdatePbm" */ '@/pages/pbm/addOrUpdatePbm.vue'
  )
}
function pbm_areaPbm() {
  return import(
    /* webpackChunkName: "page-pbm-areaPbm" */ '@/pages/pbm/areaPbm.vue'
  )
}
function pbm_create_index() {
  return import(
    /* webpackChunkName: "page-pbm-create-index" */ '@/pages/pbm/create/index.vue'
  )
}
function prescritor_create_index() {
  return import(
    /* webpackChunkName: "page-prescritor-create-index" */ '@/pages/prescritor/create/index.vue'
  )
}
function siproquim_addOrUpdateSiproquim() {
  return import(
    /* webpackChunkName: "page-siproquim-addOrUpdateSiproquim" */ '@/pages/siproquim/addOrUpdateSiproquim.vue'
  )
}
function siproquim_addSiproquim() {
  return import(
    /* webpackChunkName: "page-siproquim-addSiproquim" */ '@/pages/siproquim/addSiproquim.vue'
  )
}
function siproquim_areaSiproquim() {
  return import(
    /* webpackChunkName: "page-siproquim-areaSiproquim" */ '@/pages/siproquim/areaSiproquim.vue'
  )
}
function siproquim_editSiproquim() {
  return import(
    /* webpackChunkName: "page-siproquim-editSiproquim" */ '@/pages/siproquim/editSiproquim.vue'
  )
}
function siproquim_viewSiproquim() {
  return import(
    /* webpackChunkName: "page-siproquim-viewSiproquim" */ '@/pages/siproquim/viewSiproquim.vue'
  )
}
function typeContact_addOrUpdateContacts() {
  return import(
    /* webpackChunkName: "page-typeContact-addOrUpdateContacts" */ '@/pages/typeContact/addOrUpdateContacts.vue'
  )
}
function typeContact_areaTypesContacts() {
  return import(
    /* webpackChunkName: "page-typeContact-areaTypesContacts" */ '@/pages/typeContact/areaTypesContacts.vue'
  )
}
function users_create_index() {
  return import(
    /* webpackChunkName: "page-users-create-index" */ '@/pages/users/create/index.vue'
  )
}
function groupProducts_ensaio_create_index() {
  return import(
    /* webpackChunkName: "page-groupProducts-ensaio-create-index" */ '@/pages/groupProducts/ensaio/create/index.vue'
  )
}
function groupProducts_farmacopeia_create_index() {
  return import(
    /* webpackChunkName: "page-groupProducts-farmacopeia-create-index" */ '@/pages/groupProducts/farmacopeia/create/index.vue'
  )
}
function farmaceuticas_ensaios_edit__id() {
  return import(
    /* webpackChunkName: "page-farmaceuticas-ensaios-edit-id" */ '@/pages/farmaceuticas/ensaios/edit/_id.vue'
  )
}
function groupProducts_ensaio_edit__id() {
  return import(
    /* webpackChunkName: "page-groupProducts-ensaio-edit-id" */ '@/pages/groupProducts/ensaio/edit/_id.vue'
  )
}
function groupProducts_ensaio_view__id() {
  return import(
    /* webpackChunkName: "page-groupProducts-ensaio-view-id" */ '@/pages/groupProducts/ensaio/view/_id.vue'
  )
}
function groupProducts_farmacopeia_edit__id() {
  return import(
    /* webpackChunkName: "page-groupProducts-farmacopeia-edit-id" */ '@/pages/groupProducts/farmacopeia/edit/_id.vue'
  )
}
function groupProducts_farmacopeia_view__id() {
  return import(
    /* webpackChunkName: "page-groupProducts-farmacopeia-view-id" */ '@/pages/groupProducts/farmacopeia/view/_id.vue'
  )
}
function admcartao_edit__id() {
  return import(
    /* webpackChunkName: "page-admcartao-edit-id" */ '@/pages/admcartao/edit/_id.vue'
  )
}
function admcartao_view__id() {
  return import(
    /* webpackChunkName: "page-admcartao-view-id" */ '@/pages/admcartao/view/_id.vue'
  )
}
function farmaceuticas_edit__id() {
  return import(
    /* webpackChunkName: "page-farmaceuticas-edit-id" */ '@/pages/farmaceuticas/edit/_id.vue'
  )
}
function farmaceuticas_view__id() {
  return import(
    /* webpackChunkName: "page-farmaceuticas-view-id" */ '@/pages/farmaceuticas/view/_id.vue'
  )
}
function fornecedores_edit__id() {
  return import(
    /* webpackChunkName: "page-fornecedores-edit-id" */ '@/pages/fornecedores/edit/_id.vue'
  )
}
function fornecedores_view__id() {
  return import(
    /* webpackChunkName: "page-fornecedores-view-id" */ '@/pages/fornecedores/view/_id.vue'
  )
}
function groupPermission_edit__id() {
  return import(
    /* webpackChunkName: "page-groupPermission-edit-id" */ '@/pages/groupPermission/edit/_id.vue'
  )
}
function groupProducts_edit__id() {
  return import(
    /* webpackChunkName: "page-groupProducts-edit-id" */ '@/pages/groupProducts/edit/_id.vue'
  )
}
function groupProducts_view__id() {
  return import(
    /* webpackChunkName: "page-groupProducts-view-id" */ '@/pages/groupProducts/view/_id.vue'
  )
}
function ncm_edit__id() {
  return import(
    /* webpackChunkName: "page-ncm-edit-id" */ '@/pages/ncm/edit/_id.vue'
  )
}
function ncm_view__id() {
  return import(
    /* webpackChunkName: "page-ncm-view-id" */ '@/pages/ncm/view/_id.vue'
  )
}
function pbm_edit__id() {
  return import(
    /* webpackChunkName: "page-pbm-edit-id" */ '@/pages/pbm/edit/_id.vue'
  )
}
function pbm_view__id() {
  return import(
    /* webpackChunkName: "page-pbm-view-id" */ '@/pages/pbm/view/_id.vue'
  )
}
function prescritor_edit__id() {
  return import(
    /* webpackChunkName: "page-prescritor-edit-id" */ '@/pages/prescritor/edit/_id.vue'
  )
}
function prescritor_view__id() {
  return import(
    /* webpackChunkName: "page-prescritor-view-id" */ '@/pages/prescritor/view/_id.vue'
  )
}
function users_edit__id() {
  return import(
    /* webpackChunkName: "page-users-edit-id" */ '@/pages/users/edit/_id.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index_index,
  },
  {
    name: 'cadastros',
    path: 'cadastros',
    component: cadastros,
  },
  {
    name: 'dashboard',
    path: 'dashboard',
    component: dashboard,
  },
  {
    name: 'admcartao',
    path: 'admcartao',
    component: admcartao_index,
  },
  {
    name: 'classe',
    path: 'classe',
    component: classe_index,
  },
  {
    name: 'dcb',
    path: 'dcb',
    component: dcb_index,
  },
  {
    name: 'farmaceuticas',
    path: 'farmaceuticas',
    component: farmaceuticas_index,
  },
  {
    name: 'fornecedores',
    path: 'fornecedores',
    component: fornecedores_index,
  },
  {
    name: 'groupPermission',
    path: 'groupPermission',
    component: groupPermission_index,
  },
  {
    name: 'groupProducts',
    path: 'groupProducts',
    component: groupProducts_index,
  },
  {
    name: 'lab',
    path: 'lab',
    component: lab_index,
  },
  {
    name: 'laboratorio',
    path: 'laboratorio',
    component: laboratorio_index,
  },
  {
    name: 'methods',
    path: 'methods',
    component: methods_index,
  },
  {
    name: 'ncm',
    path: 'ncm',
    component: ncm_index,
  },
  {
    name: 'pbm',
    path: 'pbm',
    component: pbm_index,
  },
  {
    name: 'prescritor',
    path: 'prescritor',
    component: prescritor_index,
  },
  {
    name: 'users',
    path: 'users',
    component: users_index,
  },
  {
    name: 'admcartao-create',
    path: 'admcartao/create',
    component: admcartao_create_index,
  },
  {
    name: 'classe-addClasse',
    path: 'classe/addClasse',
    component: classe_addClasse,
  },
  {
    name: 'classe-editClasse',
    path: 'classe/editClasse',
    component: classe_editClasse,
  },
  {
    name: 'classe-viewClasse',
    path: 'classe/viewClasse',
    component: classe_viewClasse,
  },
  {
    name: 'classe-codigo',
    path: 'classe/codigo',
    component: classe_codigo_index,
  },
  {
    name: 'dcb-addDcb',
    path: 'dcb/addDcb',
    component: dcb_addDcb,
  },
  {
    name: 'dcb-editDcb',
    path: 'dcb/editDcb',
    component: dcb_editDcb,
  },
  {
    name: 'dcb-viewDcb',
    path: 'dcb/viewDcb',
    component: dcb_viewDcb,
  },
  {
    name: 'dcb-code',
    path: 'dcb/code',
    component: dcb_code_index,
  },
  {
    name: 'farmaceuticas-create',
    path: 'farmaceuticas/create',
    component: farmaceuticas_create_index,
  },
  {
    name: 'formasFarma-addOrUpdateFormaFarma',
    path: 'formasFarma/addOrUpdateFormaFarma',
    component: formasFarma_addOrUpdateFormaFarma,
  },
  {
    name: 'formasFarma-areaFormaFarma',
    path: 'formasFarma/areaFormaFarma',
    component: formasFarma_areaFormaFarma,
  },
  {
    name: 'fornecedores-create',
    path: 'fornecedores/create',
    component: fornecedores_create_index,
  },
  {
    name: 'groupPermission-create',
    path: 'groupPermission/create',
    component: groupPermission_create_index,
  },
  {
    name: 'groupProducts-create',
    path: 'groupProducts/create',
    component: groupProducts_create_index,
  },
  {
    name: 'groupProducts-ensaio',
    path: 'groupProducts/ensaio',
    component: groupProducts_ensaio_index,
  },
  {
    name: 'groupProducts-farmacopeia',
    path: 'groupProducts/farmacopeia',
    component: groupProducts_farmacopeia_index,
  },
  {
    name: 'groupUsers-addOrUpdate',
    path: 'groupUsers/addOrUpdate',
    component: groupUsers_addOrUpdate,
  },
  {
    name: 'groupUsers-registerClients',
    path: 'groupUsers/registerClients',
    component: groupUsers_registerClients,
  },
  {
    name: 'laboratorio-addLaboratorio',
    path: 'laboratorio/addLaboratorio',
    component: laboratorio_addLaboratorio,
  },
  {
    name: 'laboratorio-editLaboratorio',
    path: 'laboratorio/editLaboratorio',
    component: laboratorio_editLaboratorio,
  },
  {
    name: 'laboratorio-viewLaboratorio',
    path: 'laboratorio/viewLaboratorio',
    component: laboratorio_viewLaboratorio,
  },
  {
    name: 'methods-addOrUpdateMethod',
    path: 'methods/addOrUpdateMethod',
    component: methods_addOrUpdateMethod,
  },
  {
    name: 'methods-areaMethod',
    path: 'methods/areaMethod',
    component: methods_areaMethod,
  },
  {
    name: 'microComp-areaMicroComp',
    path: 'microComp/areaMicroComp',
    component: microComp_areaMicroComp,
  },
  {
    name: 'ncm-create',
    path: 'ncm/create',
    component: ncm_create_index,
  },
  {
    name: 'pbm-addOrUpdatePbm',
    path: 'pbm/addOrUpdatePbm',
    component: pbm_addOrUpdatePbm,
  },
  {
    name: 'pbm-areaPbm',
    path: 'pbm/areaPbm',
    component: pbm_areaPbm,
  },
  {
    name: 'pbm-create',
    path: 'pbm/create',
    component: pbm_create_index,
  },
  {
    name: 'prescritor-create',
    path: 'prescritor/create',
    component: prescritor_create_index,
  },
  {
    name: 'siproquim-addOrUpdateSiproquim',
    path: 'siproquim/addOrUpdateSiproquim',
    component: siproquim_addOrUpdateSiproquim,
  },
  {
    name: 'siproquim-addSiproquim',
    path: 'siproquim/addSiproquim',
    component: siproquim_addSiproquim,
  },
  {
    name: 'siproquim-areaSiproquim',
    path: 'siproquim/areaSiproquim',
    component: siproquim_areaSiproquim,
  },
  {
    name: 'siproquim-editSiproquim',
    path: 'siproquim/editSiproquim',
    component: siproquim_editSiproquim,
  },
  {
    name: 'siproquim-viewSiproquim',
    path: 'siproquim/viewSiproquim',
    component: siproquim_viewSiproquim,
  },
  {
    name: 'typeContact-addOrUpdateContacts',
    path: 'typeContact/addOrUpdateContacts',
    component: typeContact_addOrUpdateContacts,
  },
  {
    name: 'typeContact-areaTypesContacts',
    path: 'typeContact/areaTypesContacts',
    component: typeContact_areaTypesContacts,
  },
  {
    name: 'users-create',
    path: 'users/create',
    component: users_create_index,
  },
  {
    name: 'groupProducts-ensaio-create',
    path: 'groupProducts/ensaio/create',
    component: groupProducts_ensaio_create_index,
  },
  {
    name: 'groupProducts-farmacopeia-create',
    path: 'groupProducts/farmacopeia/create',
    component: groupProducts_farmacopeia_create_index,
  },
  {
    name: 'farmaceuticas-ensaios-edit-id',
    path: 'farmaceuticas/ensaios/edit/:id?',
    component: farmaceuticas_ensaios_edit__id,
  },
  {
    name: 'groupProducts-ensaio-edit-id',
    path: 'groupProducts/ensaio/edit/:id?',
    component: groupProducts_ensaio_edit__id,
  },
  {
    name: 'groupProducts-ensaio-view-id',
    path: 'groupProducts/ensaio/view/:id?',
    component: groupProducts_ensaio_view__id,
  },
  {
    name: 'groupProducts-farmacopeia-edit-id',
    path: 'groupProducts/farmacopeia/edit/:id?',
    component: groupProducts_farmacopeia_edit__id,
  },
  {
    name: 'groupProducts-farmacopeia-view-id',
    path: 'groupProducts/farmacopeia/view/:id?',
    component: groupProducts_farmacopeia_view__id,
  },
  {
    name: 'admcartao-edit-id',
    path: 'admcartao/edit/:id?',
    component: admcartao_edit__id,
  },
  {
    name: 'admcartao-view-id',
    path: 'admcartao/view/:id?',
    component: admcartao_view__id,
  },
  {
    name: 'farmaceuticas-edit-id',
    path: 'farmaceuticas/edit/:id?',
    component: farmaceuticas_edit__id,
  },
  {
    name: 'farmaceuticas-view-id',
    path: 'farmaceuticas/view/:id?',
    component: farmaceuticas_view__id,
  },
  {
    name: 'fornecedores-edit-id',
    path: 'fornecedores/edit/:id?',
    component: fornecedores_edit__id,
  },
  {
    name: 'fornecedores-view-id',
    path: 'fornecedores/view/:id?',
    component: fornecedores_view__id,
  },
  {
    name: 'groupPermission-edit-id',
    path: 'groupPermission/edit/:id?',
    component: groupPermission_edit__id,
  },
  {
    name: 'groupProducts-edit-id',
    path: 'groupProducts/edit/:id?',
    component: groupProducts_edit__id,
  },
  {
    name: 'groupProducts-view-id',
    path: 'groupProducts/view/:id?',
    component: groupProducts_view__id,
  },
  {
    name: 'ncm-edit-id',
    path: 'ncm/edit/:id?',
    component: ncm_edit__id,
  },
  {
    name: 'ncm-view-id',
    path: 'ncm/view/:id?',
    component: ncm_view__id,
  },
  {
    name: 'pbm-edit-id',
    path: 'pbm/edit/:id?',
    component: pbm_edit__id,
  },
  {
    name: 'pbm-view-id',
    path: 'pbm/view/:id?',
    component: pbm_view__id,
  },
  {
    name: 'prescritor-edit-id',
    path: 'prescritor/edit/:id?',
    component: prescritor_edit__id,
  },
  {
    name: 'prescritor-view-id',
    path: 'prescritor/view/:id?',
    component: prescritor_view__id,
  },
  {
    name: 'users-edit-id',
    path: 'users/edit/:id?',
    component: users_edit__id,
  },
]
